import React, { useEffect, useRef, useState, useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import { currentDialog, subscribeDialogs, settleDialog } from "./appDialogs";
import "./app-dialogs.css";

function Dialog({ dialog }) {
  const box = useRef(null);
  const [value, setValue] = useState(dialog.defaultValue || "");
  const cancel = () => settleDialog(dialog.id, dialog.kind === "prompt" ? null : false);
  const accept = () => settleDialog(dialog.id, dialog.kind === "prompt" ? value : true);
  useEffect(() => {
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    const background = [...document.body.children].filter(element => !element.contains(box.current)).map(element => ({ element, inert: element.inert, hidden: element.getAttribute("aria-hidden") }));
    background.forEach(({ element }) => { element.inert = true; element.setAttribute("aria-hidden", "true"); });
    document.body.style.overflow = "hidden";
    box.current?.querySelector("[data-initial-focus]")?.focus();
    return () => {
      document.body.style.overflow = overflow;
      background.forEach(({ element, inert, hidden }) => {
        element.inert = inert;
        if (hidden === null) element.removeAttribute("aria-hidden"); else element.setAttribute("aria-hidden", hidden);
      });
      if (previous?.isConnected) previous.focus();
    };
  }, []);
  const title = dialog.title || (dialog.kind === "alert" ? "CQC Toolkit" : dialog.kind === "prompt" ? "Enter details" : "Please confirm");
  return <div className="app-dialog-backdrop">
    <section ref={box} className="app-dialog" role={dialog.kind === "prompt" ? "dialog" : "alertdialog"}
      aria-modal="true" aria-labelledby={`app-dialog-title-${dialog.id}`} aria-describedby={`app-dialog-message-${dialog.id}`}
      onKeyDown={event => {
        if (event.key === "Escape") { event.preventDefault(); event.stopPropagation(); dialog.kind === "alert" ? accept() : cancel(); }
        if (event.key === "Tab") {
          const controls = [...box.current.querySelectorAll("button:not(:disabled), textarea, input")];
          const first = controls[0], last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      }}>
      <h2 id={`app-dialog-title-${dialog.id}`}>{title}</h2>
      <p id={`app-dialog-message-${dialog.id}`} className="app-dialog-message">{dialog.message}</p>
      <form onSubmit={event => { event.preventDefault(); accept(); }}>
        {dialog.kind === "prompt" && <label className="app-dialog-field">{dialog.inputLabel || "Your response"}
          <textarea data-initial-focus value={value} onChange={event => setValue(event.target.value)} rows={4}
            required={!!dialog.required} minLength={dialog.minLength} />
        </label>}
        <div className="app-dialog-actions">
          {dialog.kind !== "alert" && <button type="button" data-initial-focus={dialog.kind === "confirm" ? "true" : undefined} onClick={cancel}>{dialog.cancelLabel || "Cancel"}</button>}
          <button type="submit" className="app-dialog-primary" data-initial-focus={dialog.kind === "alert" ? "true" : undefined}>
            {dialog.confirmLabel || (dialog.kind === "alert" ? "OK" : dialog.kind === "prompt" ? "Save details" : "Continue")}
          </button>
        </div>
      </form>
    </section>
  </div>;
}
export default function AppDialogHost() {
  const dialog = useSyncExternalStore(subscribeDialogs, currentDialog, () => null);
  return dialog ? createPortal(<Dialog key={dialog.id} dialog={dialog} />, document.body) : null;
}
